import { render, staticRenderFns } from "./LightAnalysisChart.vue?vue&type=template&id=c5895626&scoped=true"
import script from "./LightAnalysisChart.vue?vue&type=script&lang=js"
export * from "./LightAnalysisChart.vue?vue&type=script&lang=js"
import style0 from "./LightAnalysisChart.vue?vue&type=style&index=0&id=c5895626&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5895626",
  null
  
)

export default component.exports